import { Entry } from '../Entry'

export function Entry20260513() {
  return (
    <Entry title="2026 May 13 - v3.11.10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/22534/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
